import axios from '@axios'
import { useApiAWS } from '@/composables/useApi'

const api = useApiAWS()

export default {
  namespaced: true,
  state: {
    item: {
      item_nome: '',
      item_descricao: 'F',
      id_categoria: '',
      ativo: null,
      imagens: [],
    },
    items: [],
  },
  getters: {
    GET_ITEMS(state) {
      return state.items
    },
  },
  mutations: {
    SET_PRODUTO_DATA(state, cliente) {
      state.cliente = cliente
    },
  },
  actions: {
    createImageItem(ctx, formData) {
      return new Promise((resolve, reject) => {
        axios
            .post('/imagens', formData)
            .then(response => resolve(response))
            .catch(error => reject(error))
      })
    },
    uploadImages(ctx, { formData }) {
      return new Promise((resolve, reject) => {
        api
            .post('/upload', formData)
            .then(response => resolve(response))
            .catch(error => reject(error))
      })
    },
    findAll(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
            .get('/items', { params: queryParams })
            .then(response => resolve(response))
            .catch(error => reject(error))
      })
    },
    save(ctx, clienteData) {
      return new Promise((resolve, reject) => {
        axios.post('/items/save', clienteData)
            .then(response => resolve(response))
            .catch(error => reject(error))
      })
    },
    update(ctx, clienteData) {
      axios.put(`/items/update/${clienteData.id}`, clienteData).then(response => {
        if (response.status === 200) {
          ctx.commit('SET_PRODUTO_DATA', response.data)
        }
      })
    },
    findById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
            .get(`/items/${id}`)
            .then(response => resolve(response))
            .catch(error => reject(error))
      })
    },
    delete(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
            .delete(`/items/${id}`)
            .then(response => resolve(response))
            .catch(error => reject(error))
      })
    },
    create(ctx, categoryData) {
      return new Promise((resolve, reject) => {
        axios
            .post('/items', categoryData)
            .then(response => resolve(response))
            .catch(error => reject(error))
      })
    },
  },
}
